import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader, TypedText } from '@/src/components/molecules';
import { Section } from '@/src/components/organisms';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  fontWeight600: {
    fontWeight: 600,
  },
  sectionContainer: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
    },
    backgroundColor: theme.palette.background.level2,
    borderRadius: '0 0 60% 0',
  },
  leftSideContent: {
    '& .section-header__cta-container': {
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        '& .section-header__cta-item-wrapper': {
          width: '100%',
          '&:last-child': {
            marginLeft: 0,
            marginTop: theme.spacing(1),
          },
          '& .MuiButtonBase-root': {
            width: '100%',
          },
        },
      },
    },
  },
  hero: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    minHeight: 470,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  section: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  sectionHeader: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      maxWidth: '55%',
      width: 'calc(100vw - 625px)',
    },
  },
  image: {
    alignSelf: 'center',
    maxWidth: 625,
    height: 'auto',
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      alignSelf: 'flex-end',
      top: '50%',
      right: 0,
      width: 'auto',
      transform: 'translateY(-50%) !important',
    },
  },
}));

const Hero = props => {
  const { className, cta, ...rest } = props;

  const classes = useStyles();

  const title = (
    <Typography variant="h2" component="span" className={classes.fontWeight600}>
      Tenha seu
      <br />
      <TypedText
        component="span"
        variant="h2"
        color="primary"
        className={classes.fontWeight600}
        typedProps={{
          strings: ['marketplace', 'e-commerce'],
          typeSpeed: 100,
          backSpeed: 50,
          loop: true,
        }}
      />
      <br />
      educacional
    </Typography>
  );

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <div className={classes.sectionContainer}>
        <div className={classes.hero}>
          <Section className={classes.section}>
            <div className={classes.sectionHeader}>
              <SectionHeader
                title={title}
                subtitle="Entregamos de forma rápida e com baixo investimento uma plataforma para venda online totalmente customizada para educação."
                align="left"
                titleProps={{
                  variant: 'h2',
                  color: 'textPrimary',
                }}
                ctaGroup={[cta]}
                disableGutter
                className={classes.leftSideContent}
              />
            </div>
          </Section>
          <Image
            src="/images/illustrations/home/hero.svg"
            alt="Eskolare"
            className={classes.image}
            lazy={false}
          />
        </div>
      </div>
    </div>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Call to action to use with Hero
   */
  cta: PropTypes.any,
};

export default Hero;
